
import { defineComponent, SetupContext, PropType, ref, computed, ComponentPublicInstance, onMounted } from "vue";
import NativeClient from "@/client/native-client";
import FridgeDetailsRadioButtonItem from "./FridgeDetailsRadioButtonItem.vue";

export default defineComponent({
  name: "FridgeDetailsRadioButton",
  components: { FridgeDetailsRadioButtonItem },
  props: {
    /** 表示する文字列 */
    labels: {
      type: Array as PropType<string[]>,
      required: true
    },
    /** 選択されたindex */
    initialSelectIndex: {
      type: Number,
      default: 0
    },
    /** ディセーブル */
    isDisable: {
      type: Boolean,
      default: false
    }
  },
  setup(props, context: SetupContext) {
    NativeClient.sendDebugLog("FridgeDetailsRadioButton setup start");
    // 選択されているindex
    const selectedIndex = ref(props.initialSelectIndex);

    interface FridgeDetailsRadioButtonItemData {
      index: number;
      text: string;
      selected: boolean;
    }
    const items = computed(() => {
      const result: Array<FridgeDetailsRadioButtonItemData> = [];
      for (const [index, value] of props.labels.entries()) {
        const element: FridgeDetailsRadioButtonItemData = { index: index, text: value, selected: false };
        if (!props.isDisable && selectedIndex.value == index) {
          element.selected = true;
        }
        result.push(element);
      }
      NativeClient.sendDebugLog("FridgeDetailsRadioButton items = " + JSON.stringify(result));
      return result;
    });

    const styleOpacity = computed(() => {
      if (props.isDisable) {
        return { 'opacity': '0.5'};
      }
      return { 'opacity': '1.0' };
    });

    // 選択された場合
    const selectItem = (index: number) => {
      if (!props.isDisable) {
        selectedIndex.value = index;
        context.emit("select-change", index);
      }
    };

    return {
      styleOpacity,
      items,
      selectItem
    };
}
});
